(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("emasm", [], factory);
	else if(typeof exports === 'object')
		exports["emasm"] = factory();
	else
		root["emasm"] = factory();
})(this, function() {
return 